import React from "react"
import { IPrivacyAgreementDocument, IUserPrivacyAgreementAcknowledgement } from "../../models"
import strings from "../../localization/strings"
import moment from "moment"
import { FontIcon } from "material-ui"
import { redA700 } from "material-ui/styles/colors"
import AcceptedIcon from "./AcceptedIcon"
interface IProps {
    isFinddPolicy?: boolean
    agreementAcknowledgements: IUserPrivacyAgreementAcknowledgement[]
    latestAgreement: IPrivacyAgreementDocument
}

const AgreementAcceptStatus: React.SFC<IProps> = (props: IProps) => {
    const agreed = props.agreementAcknowledgements &&
        props.agreementAcknowledgements.find(item => item.AgreementId === props.latestAgreement.Id)
    return (
        <div style={{ display: "flex" }}>
            {(agreed && props.latestAgreement && props.latestAgreement.Agreements) ?
                <AcceptedIcon
                    latestAgreement={props.latestAgreement}
                    keyStr={props.isFinddPolicy ? "findd_policy" : "account_agreement"}
                /> :
                <FontIcon className="fa fa-times-circle-o" color={redA700} style={{ fontSize: 16, marginTop: 2, marginRight: 5 }} />
            }
            <span>
                {props.isFinddPolicy ?
                    agreed ?
                        strings.formatString(strings.Findd_biometric_agreement_accepted_on, moment(agreed.AgreedDateTime).format("MMMM DD, YYYY")) :
                        strings.Findd_biometric_agreement_not_accepted :
                    agreed ?
                        strings.formatString(strings.Client_employee_agreement_accepted_on, moment(agreed.AgreedDateTime).format("MMMM DD, YYYY")) :
                        strings.Client_employee_agreement_not_accepted
                }
            </span>
        </div>
    )
}

export default AgreementAcceptStatus
